import { ReactNode } from 'react'

import clsx from 'clsx'

import Text, { TextColor } from '@/components/view/atoms/text/Text'
import TextField, { TextBoxSize } from '@/components/view/atoms/textfield/TextField'
import InternalLink from '@/components/view/utils/link/InternalLink'
import Logo from '@/components/view/utils/logo/Logo'

export const HEADER_HEIGHT = 57

interface Props {
  subText?: string
  onSearch?(text: string): void
  helpNode?: ReactNode
  menuNode?: ReactNode
  hiding?: boolean
  isAdmin?: boolean
}

const Header = ({
  subText = '',
  onSearch,
  helpNode,
  menuNode,
  hiding = false,
  isAdmin = false
}: Props) => {
  return (
    <header
      className={clsx(
        'z-header fixed inset-x-0 top-0 flex min-h-14.25 w-full gap-x-2 py-3',
        hiding && 'hidden',
        'bg-fill-brand-background'
      )}
    >
      <div className='flex items-center gap-x-4 px-6'>
        <InternalLink link={'/'} className='outline-default'>
          <Logo />
        </InternalLink>
        {subText.length > 0 && (
          <Text color={isAdmin ? TextColor.SECONDARY : TextColor.ON_BG_FILL_SECONDARY}>
            {subText}
          </Text>
        )}
      </div>
      {onSearch && (
        <div className='flex flex-1 justify-center'>
          <div className='grid w-full max-w-120'>
            <TextField
              type={'search'}
              value={''}
              placeholder={'商品名・受注番号'}
              size={TextBoxSize.FULL}
              suffixNode={
                <>
                  <span className='pointer-events-none block w-10 min-w-10 pr-1'>
                    <Text color={TextColor.PLACEHOLDER}>Ctrl K</Text>
                  </span>
                </>
              }
              inversion
              onChange={() => {}}
            />
          </div>
        </div>
      )}
      <div className='ml-auto flex items-center gap-x-2 px-6'>
        {helpNode}
        {menuNode}
      </div>
    </header>
  )
}

export default Header
